import { createFileRoute } from "@tanstack/react-router";
import { VoucherScreen } from "@/components/Voucher/VoucherScreen";
import { requireAuth } from "@/lib/guards";

export const Route = createFileRoute("/$locale/$partner/voucher/")({
	beforeLoad: requireAuth,
	component: VoucherIndex,
});

function VoucherIndex() {
	return <VoucherScreen voucherCode="" />;
}
